var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M4.09 14.6699C4.2 15.0649 4.405 15.4199 4.675 15.7099L0.955002 18.6549C0.845002 18.7449 0.715001 18.7849 0.595001 18.7849C0.290001 18.7849 0 18.5449 0 18.1949C0 18.0149 0.0800061 17.8449 0.225006 17.7299L4.09 14.6699Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M8.935 14.5698L13.59 18.0798C13.3 18.3648 13.1 18.7398 13.03 19.1598L8.375 15.6498C8.645 15.3448 8.84 14.9748 8.935 14.5698Z",
    fill: "#D0D7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M19.9999 16.2697V16.2997C19.9999 16.4847 19.9149 16.6547 19.7649 16.7697L16.9149 18.9147C16.7899 18.5197 16.5549 18.1747 16.2349 17.9247L19.0549 15.7997C19.4449 15.5097 19.9999 15.7847 19.9999 16.2697Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M5.1248 10.1998C4.7398 10.1998 4.4248 9.8848 4.4248 9.4998V5.4998C4.4248 5.1148 4.7398 4.7998 5.1248 4.7998C5.5098 4.7998 5.8248 5.1148 5.8248 5.4998V9.4998C5.8248 9.8848 5.5098 10.1998 5.1248 10.1998Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M7.8748 10.1998C7.4898 10.1998 7.1748 9.8848 7.1748 9.4998V2.9998C7.1748 2.6148 7.4898 2.2998 7.8748 2.2998C8.2598 2.2998 8.5748 2.6148 8.5748 2.9998V9.4998C8.5748 9.8848 8.2598 10.1998 7.8748 10.1998Z",
    fill: "#AFB8C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M9 14C9 14.195 8.975 14.385 8.935 14.57C8.84 14.975 8.645 15.345 8.375 15.65C7.92 16.17 7.25 16.5 6.5 16.5C5.75 16.5 5.135 16.195 4.675 15.71C4.405 15.42 4.2 15.065 4.09 14.67C4.03 14.455 4 14.23 4 14C4 12.62 5.12 11.5 6.5 11.5C7.88 11.5 9 12.62 9 14Z",
    fill: "#AFB8C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M17 19.5C17 20.605 16.105 21.5 15 21.5C13.895 21.5 13 20.605 13 19.5C13 19.385 13.01 19.27 13.03 19.16C13.1 18.74 13.3 18.365 13.59 18.08C13.955 17.725 14.45 17.5 15 17.5C15.46 17.5 15.89 17.66 16.23 17.925C16.55 18.175 16.785 18.52 16.91 18.915C16.965 19.1 16.995 19.295 16.995 19.5H17Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineRotate);
export default __webpack_public_path__ + "static/media/line-rotate.7b5692feb2fa9c504cc83cf501504b0a.svg";
export { ForwardRef as ReactComponent };